module.exports = __webpack_public_path__ + "img/1030690807.13a0be87.png";